export const NotificationAction = {
    Show: "notification.center.show",
    Hide: "notification.center.hide",
    Clear: "notification.clear",
    Status: "notification.status",
    Upsert: "notification.upsert",
    Delete: "notification.delete",
    Toast: "notification.toast",
};
